import { getPublicRouteUrl } from '@nackle/service-urls';

export const env = window.location.hostname
  .toLowerCase()
  .split( '.' )
  .find( function( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
  } );

function getURL( url ) {
  return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getPublicRouteUrl( 'ID_PROVIDER' );
export const companyURL = getPublicRouteUrl( 'COMPANY_SERVICE' );
export const saURL = getPublicRouteUrl( 'SERVICE_AWARDS' );
export const emailURL = getPublicRouteUrl( 'EMAIL_SERVICE_SERVICE_V1' );
export const giftCodeURL = getPublicRouteUrl( 'GIFT_CODE' );
export const companyAdminURL = getURL( 'https://(env.)company-studio.biw.cloud' );
export const giftCodeAdminURL = getURL( 'https://(env.)gift-code-studio.biw.cloud' );
export const imagesUrl = getPublicRouteUrl( 'IMAGES' );
export const rosterUrl = getPublicRouteUrl( 'ROSTER_PROXY' );
export const videoUrl = getPublicRouteUrl( 'MTC_INGEST' ) + '/v1/upload-video';
export const cmxUrl = getPublicRouteUrl( 'CMX_SERVICE_V2' );
export const cashierUrl = getPublicRouteUrl( 'CASHIER' );
export const registrationUrl = getPublicRouteUrl( 'SELF_REGISTRATION_SERVICE' ) + '/services/v1';
